import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/TeaserDeck/Card/Card.css';

export const prototypeName = 'jV1MgNal0ni2wQbXaLqrSRW55rJ7DXSL1vOvLdX0S3zMxN8NXgT0kWkzbLxkirJVbDwzM6SvA5eqJWblUZAbLR';
export {styles};